import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import SampleAcquire from "@/components/SampleAcquire";

export default function SampleLightbox() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const openH = () => setOpen(true);
    window.addEventListener("prism:open-samples", openH);
    return () => window.removeEventListener("prism:open-samples", openH);
  }, []);

  useEffect(() => {
    if (!open) return;
    const lenis = window.__lenis;
    lenis?.stop?.();
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
      lenis?.start?.();
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="sample-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Acquire material samples"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-[80] flex items-center justify-center p-4 sm:p-8"
          style={{ background: "rgba(8, 13, 22,0.90)", backdropFilter: "blur(14px)" }}
        >
          <motion.div
            data-testid="sample-lightbox-panel"
            data-lenis-prevent
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.98 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative max-h-[90vh] w-full max-w-2xl overflow-y-auto border border-[rgba(132,223,244,0.18)] bg-[#030305] px-6 py-12 shadow-[0_40px_120px_-40px_rgba(0,0,0,0.9)] sm:px-12 sm:py-16"
          >
            <button
              type="button"
              data-testid="sample-lightbox-close"
              aria-label="Close"
              onClick={() => setOpen(false)}
              className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center text-[#F5F5F7]/50 transition-colors duration-300 hover:text-[#84DFF4]"
            >
              <X size={18} />
            </button>
            <SampleAcquire />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
